import type { ColorPickerProps } from "./component-types";

const DEFAULT_COLORS = {
  bubbleColor: "#3b82f6",
  bubbleIconColor: "#ffffff",
  chatboxBgColor: "#ffffff",
  botMessageBgColor: "#f1f5f9",
  botTextColor: "#1f2937",
  userMessageBgColor: "#3b82f6",
  userTextColor: "#ffffff",
};

export function ColorPicker({ settings, onSettingsChange }: ColorPickerProps) {
  const colors = settings.dashboardConfig || {};

  function updateColor(key: string, value: string) {
    onSettingsChange({
      ...settings,
      [key]: value || DEFAULT_COLORS[key as keyof typeof DEFAULT_COLORS],
    });
  }

  return (
    <div>
      <div className="form-group">
        <label className="form-label">Preview</label>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "16px",
            background: "#f3f4f6",
            borderRadius: "8px",
          }}
        >
          <div
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              background: colors.bubbleColor || DEFAULT_COLORS.bubbleColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: colors.bubbleIconColor || DEFAULT_COLORS.bubbleIconColor,
              fontSize: "20px",
            }}
          >
            💬
          </div>
          <div style={{ flex: 1 }}>
            <div
              style={{
                padding: "8px 12px",
                background:
                  colors.botMessageBgColor || DEFAULT_COLORS.botMessageBgColor,
                color: colors.botTextColor || DEFAULT_COLORS.botTextColor,
                borderRadius: "12px 12px 12px 4px",
                fontSize: "13px",
                marginBottom: "8px",
              }}
            >
              Hi! How can I help you today?
            </div>
            <div
              style={{
                padding: "8px 12px",
                background:
                  colors.userMessageBgColor || DEFAULT_COLORS.userMessageBgColor,
                color: colors.userTextColor || DEFAULT_COLORS.userTextColor,
                borderRadius: "12px 12px 4px 12px",
                fontSize: "13px",
                marginLeft: "auto",
                width: "fit-content",
              }}
            >
              I have a question
            </div>
          </div>
        </div>
      </div>

      <div className="color-row">
        <span className="color-label">Bubble Color</span>
        <div className="color-control">
          <input
            type="color"
            className="color-input"
            value={colors.bubbleColor || DEFAULT_COLORS.bubbleColor}
            onChange={(e) => updateColor("bubbleColor", e.target.value)}
          />
          <span className="color-value">
            {colors.bubbleColor || DEFAULT_COLORS.bubbleColor}
          </span>
        </div>
      </div>

      <div className="color-row">
        <span className="color-label">Bubble Icon Color</span>
        <div className="color-control">
          <input
            type="color"
            className="color-input"
            value={colors.bubbleIconColor || DEFAULT_COLORS.bubbleIconColor}
            onChange={(e) => updateColor("bubbleIconColor", e.target.value)}
          />
          <span className="color-value">
            {colors.bubbleIconColor || DEFAULT_COLORS.bubbleIconColor}
          </span>
        </div>
      </div>

      <div className="color-row">
        <span className="color-label">Chat Box Background</span>
        <div className="color-control">
          <input
            type="color"
            className="color-input"
            value={colors.chatboxBgColor || DEFAULT_COLORS.chatboxBgColor}
            onChange={(e) => updateColor("chatboxBgColor", e.target.value)}
          />
          <span className="color-value">
            {colors.chatboxBgColor || DEFAULT_COLORS.chatboxBgColor}
          </span>
        </div>
      </div>

      <div className="color-row">
        <span className="color-label">Bot Message Background</span>
        <div className="color-control">
          <input
            type="color"
            className="color-input"
            value={colors.botMessageBgColor || DEFAULT_COLORS.botMessageBgColor}
            onChange={(e) => updateColor("botMessageBgColor", e.target.value)}
          />
          <span className="color-value">
            {colors.botMessageBgColor || DEFAULT_COLORS.botMessageBgColor}
          </span>
        </div>
      </div>

      <div className="color-row">
        <span className="color-label">Bot Text Color</span>
        <div className="color-control">
          <input
            type="color"
            className="color-input"
            value={colors.botTextColor || DEFAULT_COLORS.botTextColor}
            onChange={(e) => updateColor("botTextColor", e.target.value)}
          />
          <span className="color-value">
            {colors.botTextColor || DEFAULT_COLORS.botTextColor}
          </span>
        </div>
      </div>

      <div className="color-row">
        <span className="color-label">User Message Background</span>
        <div className="color-control">
          <input
            type="color"
            className="color-input"
            value={colors.userMessageBgColor || DEFAULT_COLORS.userMessageBgColor}
            onChange={(e) => updateColor("userMessageBgColor", e.target.value)}
          />
          <span className="color-value">
            {colors.userMessageBgColor || DEFAULT_COLORS.userMessageBgColor}
          </span>
        </div>
      </div>

      <div className="color-row">
        <span className="color-label">User Text Color</span>
        <div className="color-control">
          <input
            type="color"
            className="color-input"
            value={colors.userTextColor || DEFAULT_COLORS.userTextColor}
            onChange={(e) => updateColor("userTextColor", e.target.value)}
          />
          <span className="color-value">
            {colors.userTextColor || DEFAULT_COLORS.userTextColor}
          </span>
        </div>
      </div>
    </div>
  );
}
